"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_router_dom_1 = require("react-router-dom");
var dayjs_1 = __importDefault(require("dayjs"));
var api_1 = __importDefault(require("api"));
var QueriesStore_1 = require("stores/QueriesStore");
var UserStore_1 = require("stores/UserStore");
var TextInput_1 = __importDefault(require("components/core/inputs/TextInput"));
var use_stores_1 = require("hooks/use-stores");
var use_notification_1 = require("hooks/use-notification");
var Notification_1 = require("components/core/Notification");
var InfoRow_1 = __importDefault(require("components/core/common/InfoRow"));
var Button_1 = __importDefault(require("../../../../core/buttons/Button"));
var toBoolean = function (input) { return input === "true"; };
var PriceQueryStage4 = function (_a) {
    var data = _a.data;
    var _b = use_stores_1.useStores(), userStore = _b.userStore, queriesStore = _b.queriesStore;
    var notification = use_notification_1.useNotification();
    var timeout = react_1.useRef(null);
    var history = react_router_dom_1.useHistory();
    var changeHandler = function (e) {
        var _a;
        var value = e.currentTarget.value;
        if (value === "true" || value === "false")
            value = toBoolean(value);
        api_1.default.patchQuery(data.id, (_a = {},
            _a[e.currentTarget.name] = value,
            _a))
            .then(function (response) {
            queriesStore.editDataItem(response.data);
        }, function (error) {
            notification({
                variant: Notification_1.NotificationVariants.ERROR,
                message: "Error updating query"
            });
        });
    };
    var keyHandler = function (e) {
        var name = e.currentTarget.name;
        var value = e.currentTarget.value;
        if (timeout.current !== null)
            clearTimeout(timeout.current);
        timeout.current = setTimeout(function () {
            var _a;
            api_1.default.patchQuery(data.id, (_a = {},
                _a[name] = value,
                _a))
                .then(function (response) {
                queriesStore.editDataItem(response.data);
                notification({
                    variant: Notification_1.NotificationVariants.SUCCESS,
                    message: "Query successfully updated"
                });
            }, function (error) {
                notification({
                    variant: Notification_1.NotificationVariants.ERROR,
                    message: "Error updating query"
                });
            });
        }, 500);
    };
    var completeHandler = function () {
        if (data.priceQuery.dateCreditDebitRaised === null) {
            notification({
                variant: Notification_1.NotificationVariants.ERROR,
                message: "Please enter the Credit/Debit Raised Date"
            });
            return;
        }
        api_1.default.sendQueryForward(data.id, { currentStage: 4 })
            .then(function (response) {
            queriesStore.editDataItem(response.data);
            notification({
                variant: Notification_1.NotificationVariants.SUCCESS,
                message: "Query completed!"
            });
            setTimeout(function () {
                history.replace("/");
            }, 1000);
        }, function (error) {
            notification({
                variant: Notification_1.NotificationVariants.ERROR,
                message: "Query could not be completed due to an error"
            });
        });
    };
    var reopenHandler = function () {
        if (data.acceptedRejected !== true) {
            notification({
                variant: Notification_1.NotificationVariants.ERROR,
                message: "This query cannot be re-opened"
            });
            return;
        }
        api_1.default.reopenQuery(data.id)
            .then(function (response) {
            queriesStore.editDataItem(response.data);
            notification({
                variant: Notification_1.NotificationVariants.SUCCESS,
                message: "Query re-opened for amending at Stage 4"
            });
            setTimeout(function () {
                history.replace("/");
            }, 1000);
        }, function (error) {
            notification({
                variant: Notification_1.NotificationVariants.ERROR,
                message: "Query could not be re-opened due to an error"
            });
        });
    };
    return (react_1.default.createElement("div", { className: "price-query-stage-4" },
        react_1.default.createElement("div", { className: "flex flex-row" },
            react_1.default.createElement("div", { className: "half" }, data.status === QueriesStore_1.QueryStatus.ACTIVE &&
                data.queryStage.stage === 4 &&
                userStore.hasPermission(UserStore_1.Permissions.STAGE_4) &&
                userStore.hasPermission(UserStore_1.Permissions.PRICE_QUERY_EDIT_LEVEL_4)
                ?
                    react_1.default.createElement(TextInput_1.default, { type: "text", name: "creditDebitNumber", defaultValue: data.priceQuery.creditDebitNumber, onKeyUp: keyHandler })
                :
                    react_1.default.createElement(InfoRow_1.default, { label: "Credit/Debit Number", value: data.priceQuery.creditDebitNumber })),
            react_1.default.createElement("div", { className: "half" }, data.status === QueriesStore_1.QueryStatus.ACTIVE &&
                data.queryStage.stage === 4 &&
                userStore.hasPermission(UserStore_1.Permissions.STAGE_4) &&
                userStore.hasPermission(UserStore_1.Permissions.PRICE_QUERY_EDIT_LEVEL_4)
                ?
                    react_1.default.createElement(TextInput_1.default, { type: "date", name: "dateCreditDebitRaised", value: data.priceQuery.dateCreditDebitRaised === null && "" ||
                            dayjs_1.default(data.priceQuery.dateCreditDebitRaised).format("YYYY-MM-DD"), onChange: changeHandler })
                :
                    react_1.default.createElement(InfoRow_1.default, { label: "Date Credit/Debit Raised", value: data.priceQuery.dateCreditDebitRaised === null &&
                            "Not Set" || dayjs_1.default(data.priceQuery.dateCreditDebitRaised).format("DD/MM/YYYY") }))),
        data.status === QueriesStore_1.QueryStatus.ACTIVE &&
            data.queryStage.stage === 4 &&
            userStore.hasPermission(UserStore_1.Permissions.STAGE_4) &&
            userStore.hasPermission(UserStore_1.Permissions.PRICE_QUERY_EDIT_LEVEL_4) ?
            react_1.default.createElement(Button_1.default, { type: "button", onClick: completeHandler, title: "Complete Query" }, "Complete Query") :
            data.status === QueriesStore_1.QueryStatus.COMPLETED &&
                data.queryStage.stage === 4 &&
                data.acceptedRejected === true &&
                userStore.hasPermission(UserStore_1.Permissions.STAGE_4) &&
                userStore.hasPermission(UserStore_1.Permissions.REOPEN_QUERY) ?
                react_1.default.createElement(Button_1.default, { type: "button", onClick: reopenHandler, title: "Re-open Query Query" }, "Re-open Query") : null));
};
exports.default = PriceQueryStage4;
